import { computed, reactive } from 'vue';

const reservations = reactive({});
const defaultReservationObject = {
    tentId: 'default',
    wantsTent: null,
    placement: null,
    flagpost: 'no',
    description: ''
}

const nrOfReservations = computed(() => Object.keys(reservations).length);

export default function useReservations() {
    const addReservation = (id, initialValues = {}) => {
        if (!Object.prototype.hasOwnProperty.call(reservations, id)) {
            reservations[id] = { ...defaultReservationObject, ...initialValues };
        }
    };

    const getReservationById = (id) => {
        return reservations[id];
    };

    const updateReservation = (id, newProperties) => {
        if (reservations[id]) {
            reservations[id] = {...reservations[id], ...newProperties};
        }
    };

    const deleteReservation = (id) => {
        delete reservations[id];
    };
    const clearReservations = () => {
        for (let id of Object.keys(reservations)) {
            delete reservations[id];
        }
    };

    return {
        reservations,
        nrOfReservations,
        addReservation,
        getReservationById,
        updateReservation,
        deleteReservation,
        clearReservations,
    };
}
